import React from 'react';

import { DialogActions, DialogContent } from '@mui/material';

import Box from '@mui/material/Box';

import { useTranslation } from 'next-i18next';

import Dialog from 'src/components/ui/Dialog';
import DialogTitle from 'src/components/ui/DialogTitle';
import Typography from 'src/components/ui/Typography';
import Button from 'src/components/ui/Button';

import stopPropagation from 'src/utils/stopPropagation';
import { styledComponent } from 'src/utils/styled';

const StyledDialog = styledComponent(Dialog)`
    .MuiDialogContent-root {
        padding: 0.7rem;
    }
    .MuiDialogActions-root,
    .MuiDialogTitle-root {
        padding: 1.5rem;
    }
`;

StyledDialog.defaultProps = {
    maxWidth: 'xs',
    fullWidth: true,
};

interface Props {
    open: boolean;
    title: string;
    description: string;
    confirm: string;
    onConfirm: () => Promise<void> | void;
    onCloseOrCancel: () => Promise<void> | void;
    testid?: string;
    extraContent?: React.ReactNode;
}

const ConfirmActionModal: React.FC<Props> = ({
    open,
    title,
    description,
    confirm,
    onConfirm,
    onCloseOrCancel,
    testid = '',
    extraContent,
}) => {
    const { t } = useTranslation(['common']);
    const handleConfirm = async () => {
        await onConfirm();
    };

    return (
        <StyledDialog
            open={open}
            onClose={onCloseOrCancel}
            onClick={stopPropagation}
            onMouseDown={stopPropagation}
            data-target-id={testid}
        >
            <DialogTitle onClose={onCloseOrCancel}>
                <Typography variant="h3">{title}</Typography>
            </DialogTitle>
            <Box pl="0.7rem">
                <DialogContent>
                    <Typography
                        variant="body1"
                        dangerouslySetInnerHTML={{
                            __html: description,
                        }}
                    />
                    {extraContent}
                </DialogContent>
            </Box>
            <DialogActions>
                <Button variant="outlined" onClick={onCloseOrCancel}>
                    {t('common:modal.cancel')}
                </Button>
                <Button onClick={handleConfirm}>{confirm}</Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default ConfirmActionModal;
